import { canUseDOM } from './executionEnvironment';
import Storage from './StorageManager';

/**
 * BIG HACKS BELOW
 * This should be replaced within 3 days (from 7/29/2018) with cookie provided by API team
 * The only function below that should remain is "isLoggedIn"
 * It should only consist of one line of code that checks the new cookie for logged in value.
 */

/**
 * HACK
 * @todo remove as soon as possible
 * @returns {string} the WC_USERACTIVITY_ cookie key
 */
const getWcUserActivityCookieKey = () => {
  let result = null;
  if (canUseDOM) {
    const matches = decodeURIComponent(document.cookie).match(/WC_USERACTIVITY_\d+(?==)/);
    result = matches ? matches[0] : null;
  }
  return result;
};

/**
 * HACK
 * @todo remove as soon as possible
 * @param {string} WC_USERACTIVITY_KEY
 */
const hasWcUserActivityExpiryTime = WC_USERACTIVITY_KEY => {
  const userActivity = Storage.getCookie(WC_USERACTIVITY_KEY, false);
  const expiryTime = userActivity.split(',')[5];
  return expiryTime && expiryTime !== '' && expiryTime !== 'null';
};

/**
 * @returns {boolean} True if user is logged in, false if user is not logged in
 */
export const isLoggedIn = (checkUserType = true) => {
  const WC_USERACTIVITY_KEY = getWcUserActivityCookieKey();
  const userType = Storage.getCookie('USERTYPE');
  if (!checkUserType) {
    return WC_USERACTIVITY_KEY && hasWcUserActivityExpiryTime(WC_USERACTIVITY_KEY);
  }
  return userType === 'R' && WC_USERACTIVITY_KEY && hasWcUserActivityExpiryTime(WC_USERACTIVITY_KEY);
};

/**
 * isRememberedUser
 * @returns {boolean} True if user is remembered, false if not
 */
export const isRememberedUser = () => {
  const persistedData = Storage.getLocalStorage('PERSISTENT_SESSION');
  const userType = Storage.getCookie('USERTYPE');
  return (userType === 'R' || (persistedData && persistedData?.firstName)) && !isLoggedIn(false);
};

export const hasItemsInCart = () => {
  const userActivityCookie = Storage.getCookie('USERACTIVITY');
  const wcActivityKey = getWcUserActivityCookieKey();
  const rememberedUser = isRememberedUser();
  return (userActivityCookie && userActivityCookie > 0) || (wcActivityKey && wcActivityKey.split('_')[2] > 0) || rememberedUser;
};

const getFallBackProfileId = () => Storage.getCookie('USERACTIVITY');

/**
 * @todo change if current global implementation to get profileId changes.
 * @returns {string} the userId session storage key
 */
export const getProfileId = () => {
  const userActivityKey = getWcUserActivityCookieKey();
  const userActivityCookie = Storage.getCookie(userActivityKey, false);
  return userActivityCookie.split(',')[0] || getFallBackProfileId();
};

export const isRememberedGuestUser = () => {
  const persistentSession = Storage.getCookie('WC_PERSISTENT');
  const userActivityCookie = canUseDOM && document?.cookie?.indexOf('WC_USERACTIVITY_') > -1;
  const userType = Storage.getCookie('USERTYPE');
  return userType === 'G' && !userActivityCookie && persistentSession;
};

/**
 * gets registration status (login) of user.
 * @returns {boolean} true if user is registered or remembered.
 */
export const getRegistrationStatus = () => {
  const analyticsRegistrationStatus = isLoggedIn() || isRememberedUser();
  return analyticsRegistrationStatus;
};
